/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Alleinstellungsmerkmal_Finden32Inputs */

const en__field_enum_tuda_alleinstellungsmerkmal_finden32 = /** @type {(inputs: _Field_Enum_Tuda_Alleinstellungsmerkmal_Finden32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`find you unique selling point`)
};

const de__field_enum_tuda_alleinstellungsmerkmal_finden32 = /** @type {(inputs: _Field_Enum_Tuda_Alleinstellungsmerkmal_Finden32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleinstellungsmerkmal/ USP herausarbeiten`)
};

/**
* | output |
* | --- |
* | "find you unique selling point" |
*
* @param {_Field_Enum_Tuda_Alleinstellungsmerkmal_Finden32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_alleinstellungsmerkmal_finden32 = /** @type {((inputs?: _Field_Enum_Tuda_Alleinstellungsmerkmal_Finden32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Alleinstellungsmerkmal_Finden32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_alleinstellungsmerkmal_finden32(inputs)
	return de__field_enum_tuda_alleinstellungsmerkmal_finden32(inputs)
});
export { _field_enum_tuda_alleinstellungsmerkmal_finden32 as "_field_enum_TUDA_ALLEINSTELLUNGSMERKMAL_FINDEN" }